export const tableHeader = [
  {
    title: 'Frequency - Completion Date',
    isSortable: false,
    width: '40%',

  },
  {
    title: 'Name',
    isSortable: false,
    width: '30%',
    textAlign: 'left',
  },
  {
    title: 'Actions',
    isSortable: false,
    width: '20%',
    textAlign: 'right',
  },
];

export const tableHeaderStartDate = [
  {
    title: 'Frequency - Date Started',
    isSortable: false,
    width: '40%',
  },
  {
    title: 'Name',
    isSortable: false,
    width: '30%',
    textAlign: 'left',
  },
  {
    title: 'Actions',
    isSortable: false,
    width: '20%',
    textAlign: 'right',
  },
];

export const tableHeaderServicesDue = [
  {
    title: 'Type',
    isSortable: false,
    width: '13%',
    textAlign: 'left',
  },
  {
    title: 'Location',
    isSortable: false,
    width: '13%',
    textAlign: 'left',
  },
  {
    title: 'Floor',
    isSortable: false,
    width: '13%',
    textAlign: 'center',
  },
  {
    title: 'Make',
    isSortable: false,
    width: '13%',
    textAlign: 'center',
  },
  {
    title: 'Serial #',
    isSortable: false,
    width: '13%',
    textAlign: 'center',
  },
  {
    title: 'Size',
    isSortable: false,
    width: '11%',
    textAlign: 'center',
  },
  {
    title: 'Due For',
    isSortable: false,
    width: '12%',
    textAlign: 'center',
  },
  {
    title: 'Due date',
    isSortable: false,
    width: '12%',
    textAlign: 'right',
  },
];

export const tableHeaderServicesDone = [
  {
    title: 'Type',
    isSortable: false,
    width: '13%',
    textAlign: 'left',
  },
  {
    title: 'Location',
    isSortable: false,
    width: '13%',
    textAlign: 'left',
  },
  {
    title: 'Floor',
    isSortable: false,
    width: '13%',
    textAlign: 'center',
  },
  {
    title: 'Make',
    isSortable: false,
    width: '13%',
    textAlign: 'center',
  },
  {
    title: 'Serial #',
    isSortable: false,
    width: '13%',
    textAlign: 'center',
  },
  {
    title: 'Size',
    isSortable: false,
    width: '11%',
    textAlign: 'center',
  },
  {
    title: 'Due For',
    isSortable: false,
    width: '12%',
    textAlign: 'right',
  },
  {
    title: 'Done at',
    isSortable: false,
    width: '12%',
    textAlign: 'right',
  },
];
